/* eslint-disable new-cap */
import DestructableMeteor from '../DestructableMeteor';
import Phaser from 'phaser';
import AudioPlayer from '../../library/AudioPlayer';

export default class BonusMeteor extends DestructableMeteor {
  /**
   * 
   * @param {Phaser.Scene} game 
   * @param {*} x 
   * @param {*} y 
   * @param {*} parent 
   */
  constructor(game, x, y) {
    super(game, x, y);

    this.fallingSpeed = 150;
    game.physics.add.existing(this.sprite);

    this.SetFallingSpeed(100);
  }

  Explode() {
    super.Explode();
    AudioPlayer.PlaySound(this.game, AudioPlayer.sounds.METEOR_EXPLOSION);
  }

  FallingSpeed() {
    return this.fallingSpeed;
  }

  SetFallingSpeed(speed) {
    this.fallingSpeed = speed;

    // this.sprite.body.velocity.y = speed;
    this.sprite.body.setVelocityY(speed);
    this.sprite.body.setMaxVelocityY(speed);
  }
}


